import React from "react";
import "./Header.scss";
import Button from "../../UIComponents/Button/Button";
const Header = () => {
  return (
    <div>
      <header className="header">
        <div className="logo-box">
          <img
            src="img/AmirRezaTamandaniLogoWhite.png"
            alt="logo"
            className="logo"
          />
        </div>
        <div className="text-box">
          <h1 className="heading-primary">
            <span className="heading-primary-main">Switzerland</span>
            <span className="heading-primary-sub">
              {" "}
              One for all , all for one
            </span>
          </h1>
          <Button
            href="#mainbody"
            text="Discover More"
            btnColor="btn-color-white"
          />
        </div>
      </header>
    </div>
  );
};

export default Header;
